'use client';

import { Skeleton } from '@mui/material';
import {
  Wrapper,
  ImageWrapper,
  ContentWrapper,
  InfoWrapper,
  CardHead,
  ProjectBottomBar,
  ProjectSkeletonGallery,
  SkeletonBrokerInfo,
} from './styles';
import { StatsWrapper } from '@/components/shared/HousingCardStats/styled';

const ProjectSkeleton = () => (
  <Wrapper $isProject>
    <ProjectSkeletonGallery>
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        animation="wave"
        sx={{ gridColumn: '1 / 4', borderRadius: '6px' }}
      />
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{ borderRadius: '6px' }}
        />
      ))}
    </ProjectSkeletonGallery>
    <ContentWrapper>
      <InfoWrapper>
        {/* Office badge */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={34}
          animation="wave"
          sx={{ borderRadius: '4px' }}
        />
        <CardHead>
          <Skeleton variant="text" width="80%" height={28} animation="wave" />
          <Skeleton variant="text" width="50%" height={16} animation="wave" />
        </CardHead>
        {/* Description */}
        <div>
          <Skeleton variant="text" width="100%" height={16} animation="wave" />
          <Skeleton variant="text" width="80%" height={16} animation="wave" />
        </div>
        {/* Stats */}
        <StatsWrapper>
          <Skeleton variant="text" width="25%" height={20} animation="wave" />
          <Skeleton variant="text" width="20%" height={20} animation="wave" />
          <Skeleton variant="text" width="15%" height={20} animation="wave" />
        </StatsWrapper>
        {/* Objects list */}
        <div>
          <Skeleton variant="text" width="40%" height={18} animation="wave" sx={{ mb: '6px' }} />
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              width="100%"
              height={48}
              animation="wave"
              sx={{ mb: '1px', borderRadius: 0 }}
            />
          ))}
        </div>
        {/* Bottom bar */}
        <ProjectBottomBar>
          <Skeleton variant="circular" width={40} height={40} animation="wave" />
          <SkeletonBrokerInfo>
            <Skeleton variant="text" width="60%" height={16} animation="wave" />
            <Skeleton variant="text" width="40%" height={14} animation="wave" />
          </SkeletonBrokerInfo>
          <Skeleton
            variant="rectangular"
            width={110}
            height={34}
            animation="wave"
            sx={{ borderRadius: '6px' }}
          />
          <Skeleton
            variant="rectangular"
            width={110}
            height={34}
            animation="wave"
            sx={{ borderRadius: '6px' }}
          />
        </ProjectBottomBar>
      </InfoWrapper>
    </ContentWrapper>
  </Wrapper>
);

const DefaultSkeleton = () => (
  <Wrapper>
    <ImageWrapper>
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        animation="wave"
        sx={{ borderRadius: '6px 0 0 6px' }}
      />
    </ImageWrapper>
    <ContentWrapper>
      <InfoWrapper>
        <CardHead>
          <Skeleton variant="text" width="70%" height={23} animation="wave" />
          <Skeleton variant="text" width="50%" height={16} animation="wave" />
        </CardHead>
        <div>
          <Skeleton variant="text" width="100%" height={16} animation="wave" />
          <Skeleton variant="text" width="100%" height={16} animation="wave" />
          <Skeleton variant="text" width="80%" height={16} animation="wave" />
        </div>
        <StatsWrapper>
          <Skeleton variant="text" width="25%" height={20} animation="wave" />
          <Skeleton variant="text" width="20%" height={20} animation="wave" />
          <Skeleton variant="text" width="15%" height={20} animation="wave" />
        </StatsWrapper>
      </InfoWrapper>
    </ContentWrapper>
  </Wrapper>
);

export const HouseListCardHorizontalSkeleton = ({ isProject }: { isProject?: boolean }) =>
  isProject ? <ProjectSkeleton /> : <DefaultSkeleton />;
